import React from "react"
import { KlaviyoEmbed } from "./flexible-content-blocks/klaviyo-embed/KlaviyoEmbed"
import { Billboard } from "./flexible-content-blocks/billboard/Billboard"
import { RichText } from "./flexible-content-blocks/rich-text/RichText"
import { TextRow } from "./flexible-content-blocks/text-row/TextRow"
import { PageCarousel } from "./flexible-content-blocks/page-carousel/PageCarousel"
import { Gallery } from "./flexible-content-blocks/gallery/Gallery"
import { EmailSignup } from "./flexible-content-blocks/email-signup/EmailSignUp"
import { Facts } from "./flexible-content-blocks/facts/Facts"
import { Clamp } from "./flexible-content-blocks/clamp/Clamp"
import { Spacing } from "./flexible-content-blocks/spacing/Spacing"
import { SimpleFacts } from "./flexible-content-blocks/simple-facts/SimpleFacts"
import { ImageCta } from "./flexible-content-blocks/image-cta/ImageCta"
import { SnapshotBillboard } from "./flexible-content-blocks/snapshot-billboard/SnapshotBillboard"
import { AccordionCarousel } from "./flexible-content-blocks/accordion-carousel/AccordionCarousel"
import { TabGallery } from "./flexible-content-blocks/tab-gallery/TabGallery"
import { Contact } from "./flexible-content-blocks/contact/Contact"
import { Location } from "./flexible-content-blocks/location/Location"
import { CompetitionForm } from "./flexible-content-blocks/competition-form/CompetitionForm"
import { ShopifyGallery } from "./flexible-content-blocks/shopify-gallery/ShopifyGallery"
import { Locator } from "./flexible-content-blocks/locator/Locator"
import { CompetitionPrizes } from "./flexible-content-blocks/competition-prizes/CompetitionPrizes"
import { FAQ } from "./flexible-content-blocks/FAQ/FAQ"
import { CompetitionHeader } from "./flexible-content-blocks/competition-header/CompetitionHeader"
import { CompetitionProductHeader } from "./flexible-content-blocks/competition-product-header/CompetitionProductHeader"
import { CompetitionClosedProductHeader } from "./flexible-content-blocks/competition-closed-product-header/CompetitionClosedProductHeader"

import ShopBillboard from "./flexible-content-blocks/shop-billboard/ShopBillboard"
import { EuroHeader } from "./flexible-content-blocks/euro-header/EuroHeader"
import { Timeline } from "./flexible-content-blocks/timeline/Timeline"
import { AnchorPoint } from "./flexible-content-blocks/anchor-point/AnchorPoint"
import InstagramFeed from "./flexible-content-blocks/instagram-feed/InstagramFeed"

import { RichTextWide } from "./flexible-content-blocks/rich-text-wide/RichTextWide"
import { GermanyRichText } from "./flexible-content-blocks/germany-rich-text/GermanyRichText"
import { GermanyShotAtGlory } from "./flexible-content-blocks/germany-shot-at-glory/GermanyShotAtGlory"

import { GermanyCta } from "./flexible-content-blocks/germany-cta/GermanyCta"

const AllLayouts = ({ layoutData, pageContext, isSSR = false }) => {
  const layoutType = layoutData.__typename
  const nodeType = isSSR ? "ContentNode" : "WpContentNode" // When gathering data via SSR, the nodeType is slightly different in the schema.

  /**
   * Default component
   */

  const Default = () => (
    <div>
      In AllLayouts the mapping of this component is missing: {layoutType}
    </div>
  )

  /**
   * Mapping the fieldGroupName(s) to our components
   */
  const layouts = {
    [`${nodeType}_Flexiblecontent_Content_KlaviyoEmbed`]: KlaviyoEmbed,
    [`${nodeType}_Flexiblecontent_Content_Billboard`]: Billboard,
    [`${nodeType}_Flexiblecontent_Content_RichText`]: RichText,
    [`${nodeType}_Flexiblecontent_Content_RowText`]: TextRow,
    [`${nodeType}_Flexiblecontent_Content_Carousel`]: PageCarousel,
    [`${nodeType}_Flexiblecontent_Content_Gallery`]: Gallery,
    [`${nodeType}_Flexiblecontent_Content_EmailSignUp`]: EmailSignup,
    [`${nodeType}_Flexiblecontent_Content_Facts`]: Facts,
    [`${nodeType}_Flexiblecontent_Content_Clamp`]: Clamp,
    [`${nodeType}_Flexiblecontent_Content_Spacing`]: Spacing,
    [`${nodeType}_Flexiblecontent_Content_SimpleFacts`]: SimpleFacts,
    [`${nodeType}_Flexiblecontent_Content_ImageLink`]: ImageCta,
    [`${nodeType}_Flexiblecontent_Content_SnapshotBillboard`]:
      SnapshotBillboard,
    [`${nodeType}_Flexiblecontent_Content_AccordionCarousel`]:
      AccordionCarousel,
    [`${nodeType}_Flexiblecontent_Content_TabGallery`]: TabGallery,
    [`${nodeType}_Flexiblecontent_Content_ContactForm`]: Contact,
    [`${nodeType}_Flexiblecontent_Content_Map`]: Location,
    [`${nodeType}_Flexiblecontent_Content_CompetitionForm`]: CompetitionForm,
    [`${nodeType}_Flexiblecontent_Content_ShopifyGallery`]: ShopifyGallery,
    [`${nodeType}_Flexiblecontent_Content_ProductLocator`]: Locator,
    [`${nodeType}_Flexiblecontent_Content_CompetitionPrizes`]:
      CompetitionPrizes,
    [`${nodeType}_Flexiblecontent_Content_Faqs`]: FAQ,
    [`${nodeType}_Flexiblecontent_Content_CompetitionHeader`]:
      CompetitionHeader,
    [`${nodeType}_Flexiblecontent_Content_CompetitionProductHeader`]:
      CompetitionProductHeader,
    [`${nodeType}_Flexiblecontent_Content_CompetitionClosedProductHeader`]:
      CompetitionClosedProductHeader,
    [`${nodeType}_Flexiblecontent_Content_ShopBillboard`]: ShopBillboard,
    [`${nodeType}_Flexiblecontent_Content_EuroHeader`]: EuroHeader,
    [`${nodeType}_Flexiblecontent_Content_Timeline`]: Timeline,
    [`${nodeType}_Flexiblecontent_Content_AnchorPoint`]: AnchorPoint,
    [`${nodeType}_Flexiblecontent_Content_InstagramFeed`]: InstagramFeed,
    [`${nodeType}_Flexiblecontent_Content_RichTextWide`]: RichTextWide,
    [`${nodeType}_Flexiblecontent_Content_GermanyRichText`]: GermanyRichText,
    [`${nodeType}_Flexiblecontent_Content_GermanyShotAtGlory`]:
      GermanyShotAtGlory,
    [`${nodeType}_Flexiblecontent_Content_GermanyLink`]: GermanyCta,
    page_default: Default,
  }

  /**
   * If layout type is not existing in our mapping, it shows our Default instead.
   */

  const ComponentTag = layouts[layoutType]
    ? layouts[layoutType]
    : layouts["page_default"]

  return <ComponentTag data={layoutData} pageContext={pageContext} />
}

export default AllLayouts
